import React from "react";
import { Helmet } from "react-helmet";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import { useTranslation } from "react-i18next";
import LandscapeLighting from "../../components/landscape-lighting/LandscapeLighting";

function LandscapeLightingPage({ setShow }) {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>Landscape Lighting | Vinca Horticulture & Landscaping</title>
        <meta name="keyword" content="Vinca Horticulture & Landscaping" />
        <meta name="description" content="Vinca Horticulture & Landscaping" />
      </Helmet>
      <Breadcrumb title={"Landscape Lighting"} t={t} />
      <LandscapeLighting />
    </>
  );
}

export default LandscapeLightingPage;
